export const DOMAINS = [

  // ── 🧠 Культурный минимум ──────────────────────────────────────────────────
  {
    id: "essentials",
    icon: "🧠",
    color: "#5C7A6E",
    name: { ru: "Культурный минимум", en: "Essential Knowledge" },
    desc: { ru: "Что должен знать образованный человек XXI века", en: "What every educated person should know" },
    tracks: [
      {
        id: "dna",
        name: { ru: "Код жизни: как работает ДНК", en: "The Code of Life: How DNA Works" },
        desc: { ru: "От двойной спирали до редактирования генома", en: "From the double helix to genome editing" },
        articles: [
          { ru: "ДНК", en: "DNA" },
          { ru: "Джеймс Уотсон и Фрэнсис Крик", en: "James Watson and Francis Crick" },
          { ru: "Ген", en: "Gene" },
          { ru: "Мутация", en: "Mutation" },
          { ru: "CRISPR", en: "CRISPR" },
        ],
      },
      {
        id: "evolution",
        name: { ru: "Как появился человек", en: "How Humans Came to Be" },
        desc: { ru: "Эволюция от первых клеток до Homo sapiens", en: "Evolution from first cells to Homo sapiens" },
        articles: [
          { ru: "Происхождение жизни", en: "Abiogenesis" },
          { ru: "Теория эволюции Дарвина", en: "Darwinism" },
          { ru: "Естественный отбор", en: "Natural selection" },
          { ru: "Вымирание динозавров", en: "Cretaceous–Paleogene extinction event" },
          { ru: "Homo sapiens", en: "Homo sapiens" },
        ],
      },
      {
        id: "black_holes",
        name: { ru: "Чёрные дыры: что это такое", en: "Black Holes: What They Really Are" },
        desc: { ru: "Самые загадочные объекты во Вселенной", en: "The most mysterious objects in the universe" },
        articles: [
          { ru: "Чёрная дыра", en: "Black hole" },
          { ru: "Теория относительности Эйнштейна", en: "Theory of relativity" },
          { ru: "Горизонт событий", en: "Event horizon" },
          { ru: "Сингулярность", en: "Gravitational singularity" },
          { ru: "Излучение Хокинга", en: "Hawking radiation" },
        ],
      },
      {
        id: "internet",
        name: { ru: "Как интернет изменил человечество", en: "How the Internet Changed Humanity" },
        desc: { ru: "От военной сети до соцсетей", en: "From military network to social media" },
        articles: [
          { ru: "ARPANET", en: "ARPANET" },
          { ru: "Всемирная паутина", en: "World Wide Web" },
          { ru: "Поисковые системы", en: "Web search engine" },
          { ru: "Социальные сети", en: "Social media" },
          { ru: "Слежка в интернете", en: "Internet privacy" },
        ],
      },
      {
        id: "ai_revolution",
        name: { ru: "Революция искусственного интеллекта", en: "The AI Revolution" },
        desc: { ru: "Как машины научились думать — и что будет дальше", en: "How machines learned to think — and what comes next" },
        articles: [
          { ru: "Алан Тьюринг", en: "Alan Turing" },
          { ru: "Машинное обучение", en: "Machine learning" },
          { ru: "Нейронные сети", en: "Artificial neural network" },
          { ru: "Большие языковые модели", en: "Large language model" },
          { ru: "Технологическая сингулярность", en: "Technological singularity" },
        ],
      },
      {
        id: "democracy",
        name: { ru: "Демократия: откуда она взялась", en: "Democracy: Where It Came From" },
        desc: { ru: "От Афин до современных выборов", en: "From Athens to modern elections" },
        articles: [
          { ru: "Афинская демократия", en: "Athenian democracy" },
          { ru: "Magna Carta", en: "Magna Carta" },
          { ru: "Французская революция", en: "French Revolution" },
          { ru: "Всеобщее избирательное право", en: "Universal suffrage" },
          { ru: "Популизм", en: "Populism" },
        ],
      },
      {
        id: "relativity",
        name: { ru: "Теория относительности за 5 глав", en: "Relativity in 5 Chapters" },
        desc: { ru: "Почему время течёт по-разному", en: "Why time flows differently" },
        articles: [
          { ru: "Альберт Эйнштейн", en: "Albert Einstein" },
          { ru: "Специальная теория относительности", en: "Special relativity" },
          { ru: "Общая теория относительности", en: "General relativity" },
          { ru: "Искривление пространства-времени", en: "Spacetime" },
          { ru: "GPS и теория относительности", en: "Error analysis for the Global Positioning System" },
        ],
      },
      {
        id: "roman_empire",
        name: { ru: "Взлёт и падение Рима", en: "The Rise and Fall of Rome" },
        desc: { ru: "Как маленький город стал империей и почему рухнул", en: "How a small city became an empire and why it fell" },
        articles: [
          { ru: "Римская республика", en: "Roman Republic" },
          { ru: "Юлий Цезарь", en: "Julius Caesar" },
          { ru: "Август", en: "Augustus" },
          { ru: "Pax Romana", en: "Pax Romana" },
          { ru: "Падение Западной Римской империи", en: "Fall of the Western Roman Empire" },
        ],
      },
      {
        id: "money",
        name: { ru: "Как работают деньги", en: "How Money Works" },
        desc: { ru: "От ракушек до биткоина", en: "From shells to Bitcoin" },
        articles: [
          { ru: "История денег", en: "History of money" },
          { ru: "Центральный банк", en: "Central bank" },
          { ru: "Инфляция", en: "Inflation" },
          { ru: "Финансовый кризис 2008 года", en: "2008 financial crisis" },
          { ru: "Биткоин", en: "Bitcoin" },
        ],
      },
      {
        id: "renaissance",
        name: { ru: "Ренессанс: рождение современного мира", en: "The Renaissance: Birth of the Modern World" },
        desc: { ru: "Как Италия изменила всё", en: "How Italy changed everything" },
        articles: [
          { ru: "Ренессанс", en: "Renaissance" },
          { ru: "Леонардо да Винчи", en: "Leonardo da Vinci" },
          { ru: "Микеланджело", en: "Michelangelo" },
          { ru: "Печатный станок Гутенберга", en: "Printing press" },
          { ru: "Научная революция", en: "Scientific Revolution" },
        ],
      },
    ],
  },

  // ── 🤯 Сносит крышу ────────────────────────────────────────────────────────
  {
    id: "mind_blowing",
    icon: "🤯",
    color: "#7A5C8B",
    name: { ru: "Сносит крышу", en: "Mind-Blowing" },
    desc: { ru: "Идеи которые меняют восприятие реальности", en: "Ideas that change how you see reality" },
    tracks: [
      {
        id: "fermi",
        name: { ru: "Парадокс Ферми: где все?", en: "The Fermi Paradox: Where Is Everybody?" },
        desc: { ru: "Почему мы до сих пор не нашли инопланетян", en: "Why we haven't found aliens yet" },
        articles: [
          { ru: "Парадокс Ферми", en: "Fermi paradox" },
          { ru: "Уравнение Дрейка", en: "Drake equation" },
          { ru: "Великий фильтр", en: "Great Filter" },
          { ru: "Зонды фон Неймана", en: "Self-replicating spacecraft" },
          { ru: "Гипотеза тёмного леса", en: "Dark forest theory" },
        ],
      },
      {
        id: "simulation",
        name: { ru: "Мы живём в симуляции?", en: "Are We Living in a Simulation?" },
        desc: { ru: "Философия и физика гипотезы симуляции", en: "The philosophy and physics of the simulation hypothesis" },
        articles: [
          { ru: "Гипотеза симуляции", en: "Simulation hypothesis" },
          { ru: "Ник Бостром", en: "Nick Bostrom" },
          { ru: "Аргумент предков", en: "Ancestor simulation" },
          { ru: "Квантовая механика", en: "Quantum mechanics" },
          { ru: "Матрица (философия)", en: "Philosophical interpretation of The Matrix" },
        ],
      },
      {
        id: "ship_of_theseus",
        name: { ru: "Корабль Тесея: что такое идентичность", en: "Ship of Theseus: What Is Identity?" },
        desc: { ru: "Остаёшься ли ты собой если всё в тебе меняется", en: "Are you still you when everything about you changes" },
        articles: [
          { ru: "Парадокс корабля Тесея", en: "Ship of Theseus" },
          { ru: "Личная идентичность", en: "Personal identity" },
          { ru: "Телепортация (мысленный эксперимент)", en: "Teleportation paradox" },
          { ru: "Проблема сознания", en: "Hard problem of consciousness" },
          { ru: "Дерек Парфит", en: "Derek Parfit" },
        ],
      },
      {
        id: "boltzmann",
        name: { ru: "Мозг Больцмана и конец вселенной", en: "Boltzmann Brain and the End of Everything" },
        desc: { ru: "Самый пугающий мысленный эксперимент физики", en: "The most terrifying thought experiment in physics" },
        articles: [
          { ru: "Мозг Больцмана", en: "Boltzmann brain" },
          { ru: "Людвиг Больцман", en: "Ludwig Boltzmann" },
          { ru: "Энтропия", en: "Entropy" },
          { ru: "Тепловая смерть вселенной", en: "Heat death of the universe" },
          { ru: "Антропный принцип", en: "Anthropic principle" },
        ],
      },
      {
        id: "time",
        name: { ru: "Время: иллюзия или реальность?", en: "Time: Illusion or Reality?" },
        desc: { ru: "Что физика и философия говорят о природе времени", en: "What physics and philosophy say about the nature of time" },
        articles: [
          { ru: "Природа времени", en: "Philosophy of space and time" },
          { ru: "Стрела времени", en: "Arrow of time" },
          { ru: "Путешествие во времени", en: "Time travel" },
          { ru: "Блок-вселенная", en: "Block universe" },
          { ru: "Парадокс дедушки", en: "Grandfather paradox" },
        ],
      },
      {
        id: "infinity",
        name: { ru: "Бесконечность: математика невозможного", en: "Infinity: The Mathematics of the Impossible" },
        desc: { ru: "Почему одни бесконечности больше других", en: "Why some infinities are bigger than others" },
        articles: [
          { ru: "Бесконечность", en: "Infinity" },
          { ru: "Георг Кантор", en: "Georg Cantor" },
          { ru: "Отель Гильберта", en: "Hilbert's paradox of the Grand Hotel" },
          { ru: "Теорема Гёделя о неполноте", en: "Gödel's incompleteness theorems" },
          { ru: "Парадокс Зенона", en: "Zeno's paradoxes" },
        ],
      },
      {
        id: "free_will",
        name: { ru: "Существует ли свобода воли?", en: "Does Free Will Exist?" },
        desc: { ru: "Нейронаука и философия против интуиции", en: "Neuroscience and philosophy vs. intuition" },
        articles: [
          { ru: "Свобода воли", en: "Free will" },
          { ru: "Детерминизм", en: "Determinism" },
          { ru: "Эксперимент Либета", en: "Neuroscience of free will" },
          { ru: "Компатибилизм", en: "Compatibilism" },
          { ru: "Моральная ответственность", en: "Moral responsibility" },
        ],
      },
      {
        id: "multiverse",
        name: { ru: "Другие вселенные существуют?", en: "Do Other Universes Exist?" },
        desc: { ru: "Мультивселенная от физики до философии", en: "The multiverse from physics to philosophy" },
        articles: [
          { ru: "Мультивселенная", en: "Multiverse" },
          { ru: "Многомировая интерпретация", en: "Many-worlds interpretation" },
          { ru: "Теория струн", en: "String theory" },
          { ru: "Вечная инфляция", en: "Eternal inflation" },
          { ru: "Принцип Коперника", en: "Copernican principle" },
        ],
      },
    ],
  },

  // ── ❓ Большие вопросы ─────────────────────────────────────────────────────
  {
    id: "big_questions",
    icon: "❓",
    color: "#8B6F47",
    name: { ru: "Большие вопросы", en: "Big Questions" },
    desc: { ru: "Вопросы которые задают все — но мало кто знает ответ", en: "Questions everyone asks but few can answer" },
    tracks: [
      {
        id: "dreams",
        name: { ru: "Почему мы видим сны?", en: "Why Do We Dream?" },
        desc: { ru: "Наука и философия сновидений", en: "The science and philosophy of dreams" },
        articles: [
          { ru: "Сон", en: "Sleep" },
          { ru: "Сновидение", en: "Dream" },
          { ru: "Быстрый сон", en: "Rapid eye movement sleep" },
          { ru: "Зигмунд Фрейд и сны", en: "The Interpretation of Dreams" },
          { ru: "Теории сновидений", en: "Dream theory" },
        ],
      },
      {
        id: "consciousness",
        name: { ru: "Что такое сознание?", en: "What Is Consciousness?" },
        desc: { ru: "Самый трудный вопрос науки", en: "The hardest problem in science" },
        articles: [
          { ru: "Сознание", en: "Consciousness" },
          { ru: "Трудная проблема сознания", en: "Hard problem of consciousness" },
          { ru: "Квалиа", en: "Qualia" },
          { ru: "Философский зомби", en: "Philosophical zombie" },
          { ru: "Интегрированная информационная теория", en: "Integrated information theory" },
        ],
      },
      {
        id: "meaning_of_life",
        name: { ru: "В чём смысл жизни?", en: "What Is the Meaning of Life?" },
        desc: { ru: "Что говорят философы, учёные и религии", en: "What philosophers, scientists and religions say" },
        articles: [
          { ru: "Смысл жизни", en: "Meaning of life" },
          { ru: "Нигилизм", en: "Nihilism" },
          { ru: "Экзистенциализм", en: "Existentialism" },
          { ru: "Стоицизм", en: "Stoicism" },
          { ru: "Поток (психология)", en: "Flow (psychology)" },
        ],
      },
      {
        id: "why_civilizations_collapse",
        name: { ru: "Почему рушатся цивилизации?", en: "Why Do Civilizations Collapse?" },
        desc: { ru: "Паттерны гибели великих культур", en: "Patterns in the death of great cultures" },
        articles: [
          { ru: "Коллапс цивилизации", en: "Societal collapse" },
          { ru: "Падение Западной Римской империи", en: "Fall of the Western Roman Empire" },
          { ru: "Коллапс цивилизации майя", en: "Classic Maya collapse" },
          { ru: "Джаред Даймонд", en: "Jared Diamond" },
          { ru: "Коллапс (книга)", en: "Collapse: How Societies Choose to Fail or Succeed" },
        ],
      },
      {
        id: "dark_matter",
        name: { ru: "Что такое тёмная материя?", en: "What Is Dark Matter?" },
        desc: { ru: "95% вселенной мы не видим и не понимаем", en: "95% of the universe is invisible and unknown" },
        articles: [
          { ru: "Тёмная материя", en: "Dark matter" },
          { ru: "Тёмная энергия", en: "Dark energy" },
          { ru: "Гравитационное линзирование", en: "Gravitational lens" },
          { ru: "WIMPs", en: "Weakly interacting massive particles" },
          { ru: "Проблема скрытой массы", en: "Galaxy rotation curve" },
        ],
      },
      {
        id: "ai_consciousness",
        name: { ru: "Может ли ИИ стать сознательным?", en: "Can AI Become Conscious?" },
        desc: { ru: "Где граница между вычислением и мышлением", en: "Where is the line between computation and thinking" },
        articles: [
          { ru: "Искусственный интеллект", en: "Artificial intelligence" },
          { ru: "Тест Тьюринга", en: "Turing test" },
          { ru: "Китайская комната", en: "Chinese room" },
          { ru: "Сильный ИИ", en: "Artificial general intelligence" },
          { ru: "Права роботов", en: "Robot rights" },
        ],
      },
      {
        id: "death",
        name: { ru: "Что происходит когда мы умираем?", en: "What Happens When We Die?" },
        desc: { ru: "Наука, философия и религия о смерти", en: "Science, philosophy and religion on death" },
        articles: [
          { ru: "Смерть", en: "Death" },
          { ru: "Околосмертный опыт", en: "Near-death experience" },
          { ru: "Крионика", en: "Cryonics" },
          { ru: "Бессмертие", en: "Immortality" },
          { ru: "Эпикур о смерти", en: "Epicurus" },
        ],
      },
      {
        id: "language",
        name: { ru: "Откуда взялся язык?", en: "Where Did Language Come From?" },
        desc: { ru: "Величайшая загадка эволюции человека", en: "The greatest mystery of human evolution" },
        articles: [
          { ru: "Происхождение языка", en: "Origin of language" },
          { ru: "Гипотеза Сепира-Уорфа", en: "Linguistic relativity" },
          { ru: "Ноам Хомский", en: "Noam Chomsky" },
          { ru: "Язык жестов", en: "Sign language" },
          { ru: "Можно ли думать без слов", en: "Thinking" },
        ],
      },
    ],
  },

  // ── 🔥 Загадки ────────────────────────────────────────────────────────────
  {
    id: "mysteries",
    icon: "🔥",
    color: "#9B4A4A",
    name: { ru: "Загадки", en: "Mysteries" },
    desc: { ru: "Тайны которые до сих пор не разгаданы", en: "Mysteries that remain unsolved" },
    tracks: [
      {
        id: "dyatlov",
        name: { ru: "Перевал Дятлова: что произошло?", en: "Dyatlov Pass: What Really Happened?" },
        desc: { ru: "9 туристов, загадочная гибель, до сих пор без ответа", en: "9 hikers, mysterious deaths, still no answer" },
        articles: [
          { ru: "Гибель группы Дятлова", en: "Dyatlov Pass incident" },
          { ru: "Инфразвук", en: "Infrasound" },
          { ru: "Лавина", en: "Avalanche" },
          { ru: "Перевал Дятлова (место)", en: "Dyatlov Pass" },
          { ru: "Версии гибели группы Дятлова", en: "Dyatlov Pass incident theories" },
        ],
      },
      {
        id: "voynich",
        name: { ru: "Манускрипт Войнича: язык или мистификация?", en: "The Voynich Manuscript: Language or Hoax?" },
        desc: { ru: "Книга которую никто не может прочитать 600 лет", en: "A book nobody has been able to read for 600 years" },
        articles: [
          { ru: "Манускрипт Войнича", en: "Voynich manuscript" },
          { ru: "Криптография", en: "Cryptography" },
          { ru: "Средневековые рукописи", en: "Medieval manuscript" },
          { ru: "Вильфрид Войнич", en: "Wilfrid Voynich" },
          { ru: "Попытки расшифровки рукописи", en: "Voynich manuscript analysis" },
        ],
      },
      {
        id: "antikythera",
        name: { ru: "Механизм Антикитеры: компьютер древних", en: "The Antikythera Mechanism: Ancient Computer" },
        desc: { ru: "Устройство 2000-летней давности опередившее своё время", en: "A 2000-year-old device ahead of its time" },
        articles: [
          { ru: "Механизм Антикитеры", en: "Antikythera mechanism" },
          { ru: "Древнегреческие технологии", en: "Ancient Greek technology" },
          { ru: "Астрономия в древности", en: "History of astronomy" },
          { ru: "Кораблекрушение Антикитеры", en: "Antikythera shipwreck" },
          { ru: "Расшифровка механизма", en: "Antikythera mechanism research" },
        ],
      },
      {
        id: "wow_signal",
        name: { ru: "Сигнал Wow!: послание из космоса?", en: "The Wow! Signal: Message from Space?" },
        desc: { ru: "Единственный кандидат на внеземной сигнал в истории", en: "The only candidate for an extraterrestrial signal in history" },
        articles: [
          { ru: "Сигнал «Wow!»", en: "Wow! signal" },
          { ru: "SETI", en: "SETI" },
          { ru: "Большое ухо (телескоп)", en: "Big Ear" },
          { ru: "Радиоастрономия", en: "Radio astronomy" },
          { ru: "Внеземная жизнь", en: "Extraterrestrial life" },
        ],
      },
      {
        id: "stonehenge",
        name: { ru: "Стоунхендж: зачем его построили?", en: "Stonehenge: Why Was It Built?" },
        desc: { ru: "Мегалит которому 5000 лет и всё ещё без ответа", en: "A megalith 5000 years old and still without answers" },
        articles: [
          { ru: "Стоунхендж", en: "Stonehenge" },
          { ru: "Мегалиты", en: "Megalith" },
          { ru: "Культура колоколовидных кубков", en: "Bell Beaker culture" },
          { ru: "Солнцестояние", en: "Solstice" },
          { ru: "Теории о Стоунхендже", en: "Stonehenge theories" },
        ],
      },
      {
        id: "maya_collapse",
        name: { ru: "Куда исчезли майя?", en: "Where Did the Maya Go?" },
        desc: { ru: "Коллапс величайшей цивилизации Америки", en: "The collapse of the greatest civilization in the Americas" },
        articles: [
          { ru: "Цивилизация майя", en: "Maya civilization" },
          { ru: "Коллапс цивилизации майя", en: "Classic Maya collapse" },
          { ru: "Засуха как причина коллапса", en: "Drought and the Maya" },
          { ru: "Чичен-Ица", en: "Chichen Itza" },
          { ru: "Современные майя", en: "Maya peoples" },
        ],
      },
      {
        id: "tunguska",
        name: { ru: "Тунгусский взрыв: что это было?", en: "The Tunguska Event: What Was It?" },
        desc: { ru: "Самый мощный взрыв в истории без видимой причины", en: "The most powerful explosion in history with no visible cause" },
        articles: [
          { ru: "Тунгусское событие", en: "Tunguska event" },
          { ru: "Метеорит", en: "Meteorite" },
          { ru: "Астероид", en: "Asteroid" },
          { ru: "Планетарная защита", en: "Planetary defense" },
          { ru: "Сибирь", en: "Siberia" },
        ],
      },
      {
        id: "roanoke",
        name: { ru: "Колония Роанок: 115 человек исчезли", en: "Roanoke Colony: 115 People Vanished" },
        desc: { ru: "Первая английская колония в Америке просто пропала", en: "The first English colony in America simply disappeared" },
        articles: [
          { ru: "Потерянная колония Роанок", en: "Lost Colony of Roanoke" },
          { ru: "Ранняя история США", en: "History of the United States" },
          { ru: "Уолтер Рэли", en: "Walter Raleigh" },
          { ru: "Коренные народы Северной Америки", en: "Native Americans in the United States" },
          { ru: "Версии исчезновения колонии", en: "Theories about Roanoke Colony" },
        ],
      },
    ],
  },

  // ── 🌍 Почему мир такой ───────────────────────────────────────────────────
  {
    id: "why_world",
    icon: "🌍",
    color: "#4A7A9B",
    name: { ru: "Почему мир такой", en: "Why the World Is This Way" },
    desc: { ru: "История которая объясняет настоящее", en: "History that explains the present" },
    tracks: [
      {
        id: "cold_war",
        name: { ru: "Как началась Холодная война", en: "How the Cold War Began" },
        desc: { ru: "50 лет страха которые сформировали мир", en: "50 years of fear that shaped the world" },
        articles: [
          { ru: "Холодная война", en: "Cold War" },
          { ru: "Берлинская блокада", en: "Berlin Blockade" },
          { ru: "Карибский кризис", en: "Cuban Missile Crisis" },
          { ru: "Гонка вооружений", en: "Nuclear arms race" },
          { ru: "Распад СССР", en: "Dissolution of the Soviet Union" },
        ],
      },
      {
        id: "why_europe_conquered",
        name: { ru: "Почему Европа завоевала мир", en: "Why Europe Conquered the World" },
        desc: { ru: "Ружья, микробы и сталь", en: "Guns, germs, and steel" },
        articles: [
          { ru: "Великие географические открытия", en: "Age of Discovery" },
          { ru: "Колонизация", en: "Colonialism" },
          { ru: "Джаред Даймонд", en: "Jared Diamond" },
          { ru: "Промышленная революция", en: "Industrial Revolution" },
          { ru: "Конец колониальной эпохи", en: "Decolonization" },
        ],
      },
      {
        id: "japan",
        name: { ru: "Почему Япония такая особенная", en: "Why Japan Is So Different" },
        desc: { ru: "От самураев до аниме", en: "From samurai to anime" },
        articles: [
          { ru: "История Японии", en: "History of Japan" },
          { ru: "Самурай", en: "Samurai" },
          { ru: "Реставрация Мэйдзи", en: "Meiji Restoration" },
          { ru: "Атомные бомбардировки Хиросимы и Нагасаки", en: "Atomic bombings of Hiroshima and Nagasaki" },
          { ru: "Японское экономическое чудо", en: "Japanese economic miracle" },
        ],
      },
      {
        id: "usa_superpower",
        name: { ru: "Как США стали сверхдержавой", en: "How the US Became a Superpower" },
        desc: { ru: "От 13 колоний до мирового господства", en: "From 13 colonies to global dominance" },
        articles: [
          { ru: "Американская революция", en: "American Revolution" },
          { ru: "Гражданская война в США", en: "American Civil War" },
          { ru: "США в Первой мировой войне", en: "United States in World War I" },
          { ru: "Новый курс Рузвельта", en: "New Deal" },
          { ru: "США в эпоху холодной войны", en: "United States in the Cold War" },
        ],
      },
      {
        id: "islam",
        name: { ru: "Как возник ислам и изменил мир", en: "How Islam Emerged and Changed the World" },
        desc: { ru: "От пророка до халифата", en: "From the prophet to the caliphate" },
        articles: [
          { ru: "Мухаммед", en: "Muhammad" },
          { ru: "Ислам", en: "Islam" },
          { ru: "Арабский халифат", en: "Caliphate" },
          { ru: "Золотой век ислама", en: "Islamic Golden Age" },
          { ru: "Крестовые походы", en: "Crusades" },
        ],
      },
      {
        id: "china",
        name: { ru: "Как Китай стал Китаем", en: "How China Became China" },
        desc: { ru: "5000 лет непрерывной цивилизации", en: "5000 years of continuous civilization" },
        articles: [
          { ru: "Древний Китай", en: "Ancient China" },
          { ru: "Великая китайская стена", en: "Great Wall of China" },
          { ru: "Китайская империя", en: "Imperial China" },
          { ru: "Китайская революция", en: "Chinese Communist Revolution" },
          { ru: "Экономическое чудо Китая", en: "Chinese economic reform" },
        ],
      },
      {
        id: "holocaust",
        name: { ru: "Как стал возможен Холокост", en: "How the Holocaust Was Possible" },
        desc: { ru: "История крупнейшего геноцида XX века", en: "The history of the largest genocide of the 20th century" },
        articles: [
          { ru: "Холокост", en: "The Holocaust" },
          { ru: "Нацистская Германия", en: "Nazi Germany" },
          { ru: "Антисемитизм", en: "Antisemitism" },
          { ru: "Нюрнбергский процесс", en: "Nuremberg trials" },
          { ru: "Создание Израиля", en: "1948 Arab–Israeli War" },
        ],
      },
      {
        id: "ww2",
        name: { ru: "Вторая мировая: как это случилось", en: "World War II: How It Happened" },
        desc: { ru: "От Версаля до Хиросимы", en: "From Versailles to Hiroshima" },
        articles: [
          { ru: "Причины Второй мировой войны", en: "Causes of World War II" },
          { ru: "Блицкриг", en: "Blitzkrieg" },
          { ru: "Сталинградская битва", en: "Battle of Stalingrad" },
          { ru: "День Д", en: "Normandy landings" },
          { ru: "Атомные бомбардировки Хиросимы и Нагасаки", en: "Atomic bombings of Hiroshima and Nagasaki" },
        ],
      },
    ],
  },

  // ── 💡 Как устроено всё ───────────────────────────────────────────────────
  {
    id: "how_things_work",
    icon: "💡",
    color: "#6B7A4A",
    name: { ru: "Как устроено всё", en: "How Everything Works" },
    desc: { ru: "Механизмы которые управляют миром", en: "The mechanisms that run the world" },
    tracks: [
      {
        id: "brain_decisions",
        name: { ru: "Как мозг принимает решения", en: "How the Brain Makes Decisions" },
        desc: { ru: "Нейронаука выбора, эмоций и предубеждений", en: "The neuroscience of choice, emotion and bias" },
        articles: [
          { ru: "Человеческий мозг", en: "Human brain" },
          { ru: "Когнитивные искажения", en: "Cognitive bias" },
          { ru: "Даниэль Канеман", en: "Daniel Kahneman" },
          { ru: "Эмоции", en: "Emotion" },
          { ru: "Принятие решений", en: "Decision-making" },
        ],
      },
      {
        id: "immune_system",
        name: { ru: "Как работает иммунная система", en: "How the Immune System Works" },
        desc: { ru: "Армия внутри нас которая защищает каждую секунду", en: "The army inside us that protects every second" },
        articles: [
          { ru: "Иммунная система", en: "Immune system" },
          { ru: "Антитела", en: "Antibody" },
          { ru: "Вакцинация", en: "Vaccination" },
          { ru: "Аутоиммунные заболевания", en: "Autoimmune disease" },
          { ru: "Микробиом", en: "Microbiome" },
        ],
      },
      {
        id: "antibiotics",
        name: { ru: "Как антибиотики спасли человечество", en: "How Antibiotics Saved Humanity" },
        desc: { ru: "История открытия которое изменило медицину навсегда", en: "The discovery that changed medicine forever" },
        articles: [
          { ru: "Александр Флеминг", en: "Alexander Fleming" },
          { ru: "Пенициллин", en: "Penicillin" },
          { ru: "Антибиотики", en: "Antibiotic" },
          { ru: "Устойчивость к антибиотикам", en: "Antimicrobial resistance" },
          { ru: "Будущее антибиотиков", en: "Antibiotic resistance" },
        ],
      },
      {
        id: "capitalism",
        name: { ru: "Как устроен капитализм", en: "How Capitalism Works" },
        desc: { ru: "От Адама Смита до современной экономики", en: "From Adam Smith to the modern economy" },
        articles: [
          { ru: "Капитализм", en: "Capitalism" },
          { ru: "Адам Смит", en: "Adam Smith" },
          { ru: "Невидимая рука рынка", en: "Invisible hand" },
          { ru: "Карл Маркс", en: "Karl Marx" },
          { ru: "Глобализация", en: "Globalization" },
        ],
      },
      {
        id: "quantum",
        name: { ru: "Странные правила квантового мира", en: "The Strange Rules of the Quantum World" },
        desc: { ru: "Физика которая нарушает здравый смысл", en: "Physics that breaks common sense" },
        articles: [
          { ru: "Квантовая механика", en: "Quantum mechanics" },
          { ru: "Принцип неопределённости Гейзенберга", en: "Uncertainty principle" },
          { ru: "Квантовая запутанность", en: "Quantum entanglement" },
          { ru: "Кот Шрёдингера", en: "Schrödinger's cat" },
          { ru: "Квантовый компьютер", en: "Quantum computing" },
        ],
      },
      {
        id: "climate",
        name: { ru: "Как работает климат — и почему он меняется", en: "How Climate Works — and Why It's Changing" },
        desc: { ru: "Наука о том что происходит с нашей планетой", en: "The science of what is happening to our planet" },
        articles: [
          { ru: "Климатическая система Земли", en: "Climate system" },
          { ru: "Парниковый эффект", en: "Greenhouse effect" },
          { ru: "Глобальное потепление", en: "Global warming" },
          { ru: "Таяние ледников", en: "Retreat of glaciers since 1850" },
          { ru: "Парижское соглашение", en: "Paris Agreement" },
        ],
      },
      {
        id: "internet_works",
        name: { ru: "Как на самом деле работает интернет", en: "How the Internet Actually Works" },
        desc: { ru: "Протоколы, серверы и кабели под океаном", en: "Protocols, servers and cables under the ocean" },
        articles: [
          { ru: "Протокол TCP/IP", en: "Internet protocol suite" },
          { ru: "DNS", en: "Domain Name System" },
          { ru: "Подводные кабели связи", en: "Submarine communications cable" },
          { ru: "Шифрование", en: "Encryption" },
          { ru: "Облачные вычисления", en: "Cloud computing" },
        ],
      },
      {
        id: "space_exploration",
        name: { ru: "Как человечество вышло в космос", en: "How Humanity Reached Space" },
        desc: { ru: "От первого спутника до Марса", en: "From the first satellite to Mars" },
        articles: [
          { ru: "Спутник-1", en: "Sputnik 1" },
          { ru: "Юрий Гагарин", en: "Yuri Gagarin" },
          { ru: "Аполлон-11", en: "Apollo 11" },
          { ru: "Международная космическая станция", en: "International Space Station" },
          { ru: "SpaceX", en: "SpaceX" },
        ],
      },
    ],
  },

  // ── ⭐ Топ-20 ───────────────────────────────────────────────────────────────
  {
    id: "top20",
    icon: "⭐",
    color: "#B8860B",
    name: { ru: "Топ-20", en: "Top 20" },
    desc: { ru: "Самые известные темы Википедии — по одной истории", en: "Wikipedia's most iconic topics — one story each" },
    tracks: [
      {
        id: "einstein",
        name: { ru: "Альберт Эйнштейн", en: "Albert Einstein" },
        desc: { ru: "Человек, изменивший представление о времени и пространстве", en: "The man who changed how we see time and space" },
        articles: [
          { ru: "Альберт Эйнштейн", en: "Albert Einstein" },
        ],
      },
      {
        id: "davinci",
        name: { ru: "Леонардо да Винчи", en: "Leonardo da Vinci" },
        desc: { ru: "Художник, изобретатель, учёный — universal genius", en: "Artist, inventor, scientist — the original universal genius" },
        articles: [
          { ru: "Леонардо да Винчи", en: "Leonardo da Vinci" },
        ],
      },
      {
        id: "tesla",
        name: { ru: "Никола Тесла", en: "Nikola Tesla" },
        desc: { ru: "Изобретатель, опередивший своё время", en: "The inventor who was ahead of his time" },
        articles: [
          { ru: "Никола Тесла", en: "Nikola Tesla" },
        ],
      },
      {
        id: "cleopatra",
        name: { ru: "Клеопатра", en: "Cleopatra" },
        desc: { ru: "Последняя царица Египта и её легендарная власть", en: "Egypt's last pharaoh and her legendary reign" },
        articles: [
          { ru: "Клеопатра", en: "Cleopatra" },
        ],
      },
      {
        id: "genghis_khan",
        name: { ru: "Чингисхан", en: "Genghis Khan" },
        desc: { ru: "Как один человек создал крупнейшую империю в истории", en: "How one man built history's largest empire" },
        articles: [
          { ru: "Чингисхан", en: "Genghis Khan" },
        ],
      },
      {
        id: "aurora",
        name: { ru: "Северное сияние", en: "Aurora Borealis" },
        desc: { ru: "Почему небо иногда светится", en: "Why the sky sometimes glows" },
        articles: [
          { ru: "Полярное сияние", en: "Aurora" },
        ],
      },
      {
        id: "gravity",
        name: { ru: "Гравитация", en: "Gravity" },
        desc: { ru: "Сила, которую никто до конца не понимает", en: "The force nobody fully understands" },
        articles: [
          { ru: "Гравитация", en: "Gravity" },
        ],
      },
      {
        id: "black_hole_top",
        name: { ru: "Чёрная дыра", en: "Black Hole" },
        desc: { ru: "Место, где физика перестаёт работать", en: "Where physics stops making sense" },
        articles: [
          { ru: "Чёрная дыра", en: "Black hole" },
        ],
      },
      {
        id: "evolution_top",
        name: { ru: "Эволюция", en: "Evolution" },
        desc: { ru: "Как жизнь на Земле стала такой, какая она есть", en: "How life on Earth became what it is" },
        articles: [
          { ru: "Эволюция", en: "Evolution" },
        ],
      },
      {
        id: "placebo",
        name: { ru: "Эффект плацебо", en: "Placebo Effect" },
        desc: { ru: "Как мозг лечит тело, думая, что лечится", en: "How the mind heals the body just by believing" },
        articles: [
          { ru: "Плацебо", en: "Placebo" },
        ],
      },
      {
        id: "titanic",
        name: { ru: "Титаник", en: "Titanic" },
        desc: { ru: "Корабль, который не мог утонуть", en: "The ship that couldn't sink" },
        articles: [
          { ru: "Титаник", en: "Titanic" },
        ],
      },
      {
        id: "great_wall",
        name: { ru: "Великая Китайская стена", en: "Great Wall of China" },
        desc: { ru: "Самое длинное сооружение, построенное людьми", en: "The longest structure ever built by humans" },
        articles: [
          { ru: "Великая Китайская стена", en: "Great Wall of China" },
        ],
      },
      {
        id: "pompeii",
        name: { ru: "Помпеи", en: "Pompeii" },
        desc: { ru: "Город, застывший навсегда за один день", en: "The city frozen in time in a single day" },
        articles: [
          { ru: "Помпеи", en: "Pompeii" },
        ],
      },
      {
        id: "renaissance_top",
        name: { ru: "Ренессанс", en: "Renaissance" },
        desc: { ru: "Эпоха, которая заново изобрела человека", en: "The era that reinvented humanity" },
        articles: [
          { ru: "Ренессанс", en: "Renaissance" },
        ],
      },
      {
        id: "dna_top",
        name: { ru: "ДНК", en: "DNA" },
        desc: { ru: "Инструкция, из которой состоишь ты", en: "The instruction manual you're made of" },
        articles: [
          { ru: "ДНК", en: "DNA" },
        ],
      },
      {
        id: "human_brain",
        name: { ru: "Мозг человека", en: "Human Brain" },
        desc: { ru: "Самая сложная известная нам структура во Вселенной", en: "The most complex structure known in the universe" },
        articles: [
          { ru: "Человеческий мозг", en: "Human brain" },
        ],
      },
      {
        id: "immune_system_top",
        name: { ru: "Иммунная система", en: "Immune System" },
        desc: { ru: "Невидимая армия, которая защищает тебя прямо сейчас", en: "The invisible army protecting you right now" },
        articles: [
          { ru: "Иммунная система", en: "Immune system" },
        ],
      },
      {
        id: "meaning_of_life_top",
        name: { ru: "Смысл жизни", en: "Meaning of Life" },
        desc: { ru: "Вопрос, на который философы отвечают тысячи лет", en: "The question philosophers have chased for millennia" },
        articles: [
          { ru: "Смысл жизни", en: "Meaning of life" },
        ],
      },
      {
        id: "stoicism_top",
        name: { ru: "Стоицизм", en: "Stoicism" },
        desc: { ru: "Древняя философия, которая снова в моде", en: "The ancient philosophy that's trending again" },
        articles: [
          { ru: "Стоицизм", en: "Stoicism" },
        ],
      },
      {
        id: "fermi_paradox_top",
        name: { ru: "Парадокс Ферми", en: "Fermi Paradox" },
        desc: { ru: "Если инопланетяне есть — то где они?", en: "If aliens exist, where are they?" },
        articles: [
          { ru: "Парадокс Ферми", en: "Fermi paradox" },
        ],
      },
    ],
  },
];